module.exports = __webpack_public_path__ + "media/img/home/clients-map/usa-d39db3d2e6e87cf826f993cf60f58b1b.png";